import React from "react";
import "./App.css";
import TimezoneConverter from "./components/TimezoneConverter";

function App() {
  return <TimezoneConverter />;
}

export default App;
